import { useIntl } from 'react-intl';

import ColumnSelector, { type ColumnKey } from '../ColumnSelector';
import Select from '../Select';
import './styles.css';

export type ViewMode = 'table' | 'kanban';

type ResultHeaderProps = {
    count: number;
    sort: string;
    view: ViewMode;
    onSortChange: (sort: string) => void;
    onViewChange: (view: ViewMode) => void;
    onExport: () => void;
    visibleColumns: ColumnKey[];
    onVisibleColumnsChange: (columns: ColumnKey[]) => void;
    openNewAEGModal: () => void;
};

export default function ResultHeader({
    count,
    sort,
    view,
    onSortChange,
    onViewChange,
    onExport,
    visibleColumns,
    onVisibleColumnsChange,
    openNewAEGModal
}: ResultHeaderProps) {
    const intl = useIntl();

    return (
        <header className='aeg-result-header-root display-flex align-items-center flex-wrap gap-10 padding-15 border border-bottom-only border-left-none border-right-none border-top-none'>
            <strong className='aeg-result-header-count text-color-darkest'>{intl.formatMessage({ id: 'intl-msg:support.aeg.requests.count' }, { count })}</strong>
            <div className='flex-1-1' />
            <Select
                ariaLabel={intl.formatMessage({ id: 'intl-msg:support.aeg.sort.label' })}
                onChange={onSortChange}
                options={[
                    { value: 'recent', label: intl.formatMessage({ id: 'intl-msg:support.aeg.sort.recent' }) },
                    { value: 'old', label: intl.formatMessage({ id: 'intl-msg:support.aeg.sort.old' }) },
                    { value: 'value-high', label: intl.formatMessage({ id: 'intl-msg:support.aeg.sort.valueHigh' }) },
                    { value: 'value-low', label: intl.formatMessage({ id: 'intl-msg:support.aeg.sort.valueLow' }) },
                ]}
                prefix={intl.formatMessage({ id: 'intl-msg:support.aeg.sort.label' })}
                value={sort}
            />
            <div className='aeg-result-header-segment'>
                <button
                    className={`btn ${view === 'table' ? 'btn-primary' : 'btn-default'}`}
                    onClick={() => onViewChange('table')}
                    type='button'
                >
                    {intl.formatMessage({ id: 'intl-msg:support.aeg.view.list' })}
                </button>
                <button
                    className={`btn ${view === 'kanban' ? 'btn-primary' : 'btn-default'}`}
                    onClick={() => onViewChange('kanban')}
                    type='button'
                >
                    {intl.formatMessage({ id: 'intl-msg:support.aeg.view.kanban' })}
                </button>
            </div>
            <ColumnSelector onChange={onVisibleColumnsChange} selectedColumns={visibleColumns} />
            <button className='btn btn-default' onClick={onExport} type='button'>
                {intl.formatMessage({ id: 'intl-msg:support.aeg.action.export' })}
            </button>
            <button onClick={openNewAEGModal} className='btn btn-primary' type='button'>
                {intl.formatMessage({ id: 'intl-msg:support.aeg.action.new' })}
            </button>
        </header>
    );
}
